module.exports = __webpack_public_path__ + "fonts/0efcbde0f31c416276d8f527c643d72d.txt";